module.exports = __webpack_public_path__ + "labioplastika_6_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_6_before.jpg
// module id = 1078
// module chunks = 0